<template>
	<div class="dialog-wrap">
		<div class="dialog-detail">
			<img src="../assets/img/close.png" class="close" @click="close">
			<p class="time-wrap" v-if='type == "pay" && pay_end_time'>支付倒计时：<span class="time">{{pay_end_time}}</span></p>
			<div class="amount-wrap"><span class="amount">¥{{chargeMoney}}</span></div>
			<ul>
				<li :class='payStyle==1?"current":""' @click="changePayType(1)"><span class="we-chat">微信支付</span></li>
				<li :class='payStyle==3?"current":""' @click="changePayType(3)"><span class="alipay">支付宝</span></li>
				<li :class='payStyle==2?"current":""' @click="changePayType(2)" v-if='type != "charge" && !isAppend'><span class="balance">账户余额(¥{{walletInfo.available_balance}})</span></li>
			</ul>

			<div class="qrcode-wrap" v-if='payStyle!=2'>
				<qr-code :qrcodeUrl="qrcodeUrl" v-if='qrcodeUrl'></qr-code>
                <img src="../assets/img/wait.gif" class="wait" v-else>
			</div>

			<div class="send-wrap" v-show='payStyle==2'>
				<p v-if='type != "charge"' @click="goToCharge">
					<span v-for='(item,index) in rechargeList' :key="index">充{{item.recharge_money | filterNum}}送{{item.recharge_amount | filterNum}}&nbsp;</span>
				</p>
				<div @click="submit">确认支付</div>
			</div>

			<div v-if='type != "charge"'>
				<p class="favourable" v-show='payStyle!=2 && Number(order_member_price)'>已优惠<span>{{order_member_price}}</span>元</p>
				<p class="support-plan">保障计划：未解决订单及时退<span @click="isPlanShow=true"></span></p>
			</div>
		</div>

		<!-- 保障计划 -->
		<support-plan-modal v-if="isPlanShow" @close="isPlanShow = false" @showAgreeMent="isShowAgree = true"></support-plan-modal>
		<!-- 下单协议 -->
		<agree-ment-modal v-if="isShowAgree" @close="isShowAgree = false;isPlanShow = true"></agree-ment-modal>
	</div>
</template>

<script>
	import utils from '@/assets/js/utils';
	import qrCode from '@/components/qrCode';
	import agreeMentModal from '@/components/agreeMentModal';
	import supportPlanModal from '@/components/supportPlanModal';
	import { getOrderPay, getOrderDetail,getOrderAddPay,getAddPayStatus} from '@/api/order.js';
	import {getRechargeClassList,postRecharge,getChargeStatus} from '@/api/recharge.js'
	import {
		mapState,
		mapActions
	} from "vuex";
	export default {
		props: {
			chargeMoney: {
				type: String,
				default: ""
			},

			order_member_price:{
				type: String,
				default: ""
			},

			order_uuid:{
				type: String,
				default: ""
			},

			//充值档次id
			uuid:{
				type: String,
				default: ""
			},

			//追加金额支付订单
			add_order_uuid:{
				type: String,
				default: ""
			},

			//追加金额的备注用途
			addContent:{
				type: String,
				default: ""
			},

			type: {
				type: String,
				default: "charge"
			},

            isAppend:{
                type: Boolean,
                default:false,
            },
		},

		data() {
			return {
				payStyle: 1, //支付方式
				isPlanShow: false,
				isShowAgree: false,
				qrcodeUrl:"",
				clickPay:true,
				isRepeat:true,				//是否轮训支付状态
				timer: null, 				//轮训支付状态
				rechargeList:[],
				recharge_uuid:"",			//充值订单号
				isRechargeRepeat:true,		//是否轮训充值状态
				rechargeTimer:null,			// 轮训充值状态
				isAddRepeat:true,			//是否轮训追加费用支付状态
				addTimer:null,				// 轮训追加费用状态
				pay_end_time:null,				//支付倒计时
				payTimer:null
			}
		},

		mounted() {
			if(this.type != "charge"){
				this.getMyWallet();
			}
			this.getRechargeClassList()
		},

		computed: {
			...mapState(["walletInfo"]),
		},

		methods: {
			...mapActions(["getMyWallet"]),
			//确定使用余额
			submit(){
				if(this.type == "pay"){//支付
					this.payClick(2)
				}
				else if(this.type == "add"){//追加订单
					this.payAddClick(2)
				}
			},

			//确认支付
			async payClick(payStyle) {
				if(payStyle == '2'){
					if (!this.clickPay) {
						this.$message('请勿重复点击');
						return;
					}
					this.clickPay = false;
					setTimeout(() => {
						this.clickPay = true;
					}, 3000);
				}
				this.clearTimer();
				const obj = {type: payStyle,order_uuid: this.order_uuid,order_tag: 2};
				const {data,status} = await getOrderPay(obj);
				if (status == 200) {
					if (payStyle == '2') {// 钱包支付
						this.close();
						this.$emit("getCallBack");
					} else if (payStyle == '1') {// 微信支付
						this.isRepeat = true;
						this.qrcodeUrl = "";
						this.qrcodeUrl = data.code_url;
						this.order_uuid = data.order_uuid;
						// this.pay_end_time = data.pay_end_time;
						this.countDown(data.pay_end_time);
						this.getPayStatus();
					} else if (payStyle == '3') {// 支付宝支付
						this.isRepeat = true;
						this.qrcodeUrl = "";
						this.qrcodeUrl = data.code_url;
						this.order_uuid = data.order_uuid;
						this.getPayStatus();
					}
				} else {
					if (payStyle == '2') {
						this.$message((data.error && data.error.message) || '余额不足,请充值');
						return;
					}
				}
			},

			// 轮询订单支付状态
			async getPayStatus() {
				vm.isLoading = true;				//轮询接口只loading一次，防止重复loadings
				this.clearTimer();
				if(!this.isRepeat) return
				const {data,status} = await getOrderDetail(this.order_uuid);
				if (status == 200 && data.is_pay == 2) {
					vm.isLoading = false;
					this.close();
					this.$emit("getCallBack");
				} else {
					this.clearTimer();
					this.timer = setTimeout(() => {
						this.getPayStatus();
					}, 2000);
				}
			},

			//确认充值
			async payRecharge(payStyle){
				this.clearRechargeTimer();
				let obj={type:payStyle,uuid:this.uuid,order_tag : 2};
				const { data, status } = await postRecharge(obj);
				if( status == 200 ){
					this.isRechargeRepeat = true;
					this.qrcodeUrl = "";
					this.qrcodeUrl = data.code_url;
				    this.recharge_uuid = data.order_uuid;
					this.getChargeStatus()
				}
			},

			//轮询充值状态
			async getChargeStatus(){
				vm.isLoading = true;				//轮询接口只loading一次，防止重复loadings
				this.clearRechargeTimer();
				if(!this.isRechargeRepeat) return
				const { data, status } = await getChargeStatus(this.recharge_uuid);
				if( status == 200 && data.is_pay == 2){
					vm.isLoading = false;
					this.clearRechargeTimer();
					this.$message.success("充值成功");
					this.close();
					this.$emit("chargeBack")
				}else{
					this.clearRechargeTimer();
					this.rechargeTimer = setTimeout(()=>{
						this.getChargeStatus()
					},2000)
				}
			},

			//确认追加订单支付
			async payAddClick(payStyle){
				if(payStyle == '2'){
					if (!this.clickPay) {
						this.$message('请勿重复点击');
						return;
					}
					this.clickPay = false;
					setTimeout(() => {
						this.clickPay = true;
					}, 3000);
				}
			    this.clearAddTimer();
				let obj={add_order_uuid:this.add_order_uuid,type:payStyle,order_tag: 2};
				const { data, status } = await getOrderAddPay(obj);
				if(status==200){//成功支付之后，关闭支付弹框
					if(payStyle=="2"){//钱包支付
						this.$message.success("追加费用成功");
						this.close();
						this.$emit("addBack");
					}
					else{
						this.isAddRepeat = true;
						this.qrcodeUrl = "";
						this.qrcodeUrl = data.code_url;
						this.add_order_uuid = data.add_order_uuid;
						this.getAddPayStatus();
					}
				}else{
				    if (payStyle == '2') {
				    	this.$message((data.error && data.error.message) || '余额不足,请充值');
				    	return;
				    }
				}
			},

			// 轮询追加金额订单支付状态
			async getAddPayStatus(){
				vm.isLoading = true;				//轮询接口只loading一次，防止重复loadings
				this.clearAddTimer();
				if(!this.isAddRepeat) return
				const { data, status } = await getAddPayStatus(this.add_order_uuid);
                if(status == 200 && data.is_pay == 2){//追加支付成功
                    vm.isLoading = false;
                    this.$message.success("追加费用成功");
                    this.close();
                    this.$emit("addBack");
                }else{
                    this.clearAddTimer();
                    this.addTimer = setTimeout(()=>{
                        this.getAddPayStatus()
                    },2000)
                }
			},

			changePayType(type){
				this.qrcodeUrl = "";
				vm.isLoading = false;
				this.clearTimer();
				this.clearRechargeTimer();
				this.clearAddTimer();
				this.isRepeat = false;
				this.isRechargeRepeat = false;
				this.isAddRepeat = false;
                this.payStyle = type;
				if(this.type == "charge"){//充值
					this.payRecharge(type);
				}
				else if(this.type == "pay"){//支付
					if(type!=2){
						this.payClick(type);
					}
				}else if(this.type == "add"){//追加订单支付
					if(type!=2){
						this.payAddClick(type);
					}
				}
			},

			//支付轮训定时器
			clearTimer(){
				if(this.timer){
					clearTimeout(this.timer);
				}
			},

			//充值轮训定时器
			clearRechargeTimer(){
				if(this.rechargeTimer){
					clearTimeout(this.rechargeTimer);
				}
			},

			//追加费用支付定时器
			clearAddTimer(){
				if(this.addTimer){
					clearTimeout(this.addTimer);
				}
			},

			//获取充值机奖励
			async getRechargeClassList(){
				const { data, status } = await getRechargeClassList();
				if (status !== 200) return
				if(data.char && data.char.length > 2){
					this.rechargeList = data.char.slice(0,2)
				}else{
					this.rechargeList = data.char
				}
			},

			//返回列表
			backList(){
				this.isSuccess = false;
				this.$emit("getOrderList")
			},

			// 去充值
			goToCharge() {
				var backUrl = location.href
				this.$router.push({
					path: "./recharge",
					query: {
						url: encodeURIComponent(backUrl)
					}
				})
			},

			close() {
				vm.isLoading = false;
				this.isRepeat = false;			//防止关闭弹框时，轮训定时器还未触发，此时清除定时器无作用，导致弹框关闭之后，定时器继续触发
				this.isRechargeRepeat = false;
				this.isAddRepeat = false;
				this.clearTimer();
				this.clearRechargeTimer();
				this.clearAddTimer();
				this.$emit('close');
			},

			//支付倒计时
			countDown(count) {
				if (!this.payTimer) {
					this.payTimer = setInterval(() => {
						count --
						var minutes = parseInt(count/60%60);
						var seconds = parseInt(count%60);
						this.pay_end_time = minutes + "分" + seconds + "秒"
						if(count < 1){
							this.pay_end_time = null
							clearInterval(this.payTimer);
							this.payTimer = null;
							this.$message("支付超时");
							this.close();
						}
					}, 1000);
				}
			},
		},

		filters:{
			filterNum(val){
				if(String(val).includes(".")){
					let index = String(val).indexOf(".")
					return String(val).slice(0,index)
				}else{
					return val
				}
			},
		},

		components: {
			qrCode,
			agreeMentModal,
			supportPlanModal
		}
	};
</script>

<style lang="scss" scoped>
	.dialog-wrap {
		// position: absolute;
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		z-index: 9;
		top: 0;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
		.dialog-detail {
			position: relative;
			width: 880px;
			padding: 25px 0;
			// margin: 100px auto 0 auto;
			background: #FFFFFF;
			box-shadow: 0px 13px 7px 0px rgba(0, 0, 0, 0.06);
			.close {
				position: absolute;
				right: 20px;
				top: 20px;
				width: 11px;
				height: 11px;
				cursor: pointer;
			}

			.time-wrap {
				text-align: center;
				font-size: 14px;
				@include font-style;
				color: #666666;
				.time {
					color: #FF8D1C;
				}
			}

			.amount-wrap {
				margin: 16px 0 16px 0;
				text-align: center;
				font-size: 24px;
				font-family: Microsoft YaHei;
				font-weight: bold;
				color: #FF8D1C;

				.amount {
					font-size: 48px;
				}
			}

			ul {
				display: flex;
				align-items: center;
				justify-content: center;

				li {
					width: 240px;
					cursor: pointer;
					// padding: 0 40px;
					height: 48px;
					line-height: 48px;
					text-align: center;
					margin-right: 30px;
					background: #FFFFFF;
					border: 1px solid #666666;
					font-size: 18px;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #666666;
					box-sizing: border-box;
					box-shadow: 0px 8px 10px 0px rgba(31, 56, 117, 0.08);
					border-radius: 5px;

					span {
						padding-left: 30px;
					}

					.we-chat {
						background: url(../assets/img/weChat.png) no-repeat left center;
						background-size: 20px 20px;
					}

					.alipay {
						background: url(../assets/img/alipay.png) no-repeat left center;
						background-size: 20px 20px;
					}

					.balance {
						background: url(../assets/img/balance.png) no-repeat left center;
						background-size: 20px 20px;
					}
				}

				.current {
					color: #FF8D1C;
					border: 1px solid #FF8D1C;
				}

				li:last-child {
					margin-right: 0
				}
			}
			.qrcode-wrap{
				display: flex;
				align-items: center;
				justify-content: center;
				width: 202px;
				height: 202px;
				background: #fff;
				margin: 30px auto 20px auto;
				border: 1px solid #FF8D1C;
                img{
                    width: 200px;
                }
                .wait{
                    width: 100px;
                }
			}

			.send-wrap {
				margin-top: 150px;
				text-align: center;

				p {
					display: inline-block;
					margin-bottom: 10px;
					text-align: center;
					font-size: 18px;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #FF8D1C;
					padding-right: 18px;
					background: url(../assets/img/arrow-right.png) no-repeat right center;
					background-size: 8px;
					@include cursor-style
				}

				div {
					width: 280px;
					height: 60px;
					margin: 0 auto;
					line-height: 60px;
					text-align: center;
					background: #ff8d1c;
					box-shadow: 0px 3px 6px 0px rgba(102, 102, 102, .16);
					border-radius: 5px;
					font-size: 20px;
					font-family: Microsoft YaHei;
					font-weight: bold;
					color: #fff;
					@include cursor-style
				}
			}

			.favourable {
				margin-bottom: 10px;
				text-align: center;
				font-size: 18px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #FF8D1C;
			}

			.support-plan {
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 14px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #999999;
				margin-top: 10px;

				span {
					display: inline-block;
					vertical-align: middle;
					width: 14px;
					height: 14px;
					background: url(../assets/img/question.png) no-repeat center center;
					background-size: 100%;
					margin-left: 8px;
					@include cursor-style
				}
			}
		}
	}
</style>
